




































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Comune } from '@/data/models/comune.model';
import { Provincia } from '@/data/models/provincia.model';
import { Search } from '@/data/models/search.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import store, { State } from '@/store';
import { ContactCategory, ContattoStatus } from '@/data/models/contatto.model';
import { date2Num, dateEndofDay, newDate } from '@/data/utils/helper';
import { CampaignCallStatus } from '@/data/models/campaign.model';

@Component
export default class CampagnaContattiFilter extends Vue {
	@Ref('autocompleteprovincia') autocompleteprovincia: any;
	@Ref('autocompletecomune') autocompletecomune: any;

	advancedSearch: Search;

	searchParam: any = new class {
		category?: ContactCategory;
		province?: string;
		comune?: Comune;
		zipcode?: string;
		dates?: Date[];
		calldate?: Date[];
		city?: string;
		callstatus?: string;
	};

	excludeCallDate = false;

	provinciaClass: ClassType<Provincia> = Provincia;
	comuneClass: ClassType<Comune> = Comune;

	state!: State;

	typeItems: string[] = Object.keys(ContactCategory).map(
		// @ts-ignore
		(k: string) => ContactCategory[k]
	);
	callstatusItems: string[] = Object.keys(CampaignCallStatus).map(
		// @ts-ignore
		(k: string) => CampaignCallStatus[k]
	);

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('contact left join lastoffer on lastoffer.contactid = contact.id left join lastcall on lastcall.contactid = contact.id');
	}

	search() {
		this.advancedSearch.reset();

		this.advancedSearch.addSimpleFilter('contact.hqid', this.state.headquarter!.id);
		this.advancedSearch.addSimpleFilter('contact.status', ContattoStatus.ACTIVE);

		if (this.searchParam.category) this.advancedSearch.addSimpleFilter('contact.category', this.searchParam.category);
		if (this.searchParam.province && this.searchParam.province.id) this.advancedSearch.addSimpleFilter('contact.province', this.searchParam.province.descrizione);
		if (this.searchParam.comune && this.searchParam.comune.id) this.advancedSearch.addSimpleFilter('contact.comune', this.searchParam.comune.descrizione);
		if (this.searchParam.zipcode) this.advancedSearch.addLikeFilter('contact.zipcode', this.searchParam.zipcode);
		if (this.searchParam.city) this.advancedSearch.addLikeFilter('contact.city', this.searchParam.city);

		if (this.searchParam.dates && this.searchParam.dates.length) {
			const start = this.searchParam.dates[0] ? date2Num(this.searchParam.dates[0]) : 0;
			const end = this.searchParam.dates[1] ? date2Num(dateEndofDay(this.searchParam.dates[1])) : newDate(true).getTime();
			this.advancedSearch.addRangeFilter('lastoffer.insdate', start as number, end as number);
		}

		if (this.searchParam.calldate && this.searchParam.calldate.length) {
			const start = this.searchParam.calldate[0] ? date2Num(this.searchParam.calldate[0]) : 0;
			const end = this.searchParam.calldate[1] ? date2Num(dateEndofDay(this.searchParam.calldate[1])) : newDate(true).getTime();
			if (this.excludeCallDate) {
				this.advancedSearch.addNotInRangeFilter('lastcall.calldate', start as number, end as number);
				this.advancedSearch.removeRangeFilter('lastcall.calldate');
			} else {
				this.advancedSearch.addRangeFilter('lastcall.calldate', start as number, end as number);
				this.advancedSearch.removeNotInRangeFilter('lastcall.calldate');
			}
		}

		if (this.searchParam.callstatus) {
			this.advancedSearch.addSimpleFilter('lastcall.status', this.searchParam.callstatus);
		}

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.category = undefined;
		this.searchParam.zipcode = undefined;
		this.searchParam.province = {};
		this.searchParam.comune = {};
		this.searchParam.dates = undefined;
		this.searchParam.calldate = undefined;
		this.searchParam.callstatus = undefined;
		this.search();
	}

}
